import { Fragment, useEffect } from "react"
import { useFormContext, useWatch } from "react-hook-form"
import { useCodePaymentBillService } from "../hooks"
import { PaymentBillServiceSchema } from "../schema"

type PaymentBillServiceCodeProps = {
  value?: string
}

export const PaymentBillServiceCode = ({ value }: PaymentBillServiceCodeProps) => {
  const { refetch } = useCodePaymentBillService()

  const { control, formState, setValue } = useFormContext<PaymentBillServiceSchema>()
  const transaction_date = useWatch({ control, name: "transaction_date" })
  const trx_code = useWatch({ control, name: "trx_code" })
  
  useEffect(() => {
    if (!formState.defaultValues?.trx_code) {
      refetch(transaction_date).then(res => {
        setValue("trx_code", res)
        localStorage.setItem("trx_code_payment_bill", res)
      })
    }

    // eslint-disable-next-line
  }, [formState, transaction_date])
  
  return <Fragment>{value ?? trx_code}</Fragment>
}